const TableControls = ({filter, handleFilterChange, selectedProduct, setSelectedProduct}) => {

    const btnArray = [{name: 'Все вместе', active: 'all'},
    {name: 'Новые', active: 'new'}, 
    {name: 'В работе', active: 'inwork'} , 
    {name: 'Завершенные', active: 'complete'}]

    return ( 
        <form action="">
            <div className="row mb-3 justify-content-start">
                <div className="col">
                    <div id="topStatusBar" className="btn-group" role="group" aria-label="...">
                        {btnArray.map((btn) => (
                            <div key={btn.active} 
                            className={`btn btn-light${filter === btn.active ? ' active' : ''}`} 
                            onClick={() => handleFilterChange(btn.active)}>{btn.name}</div>
                        ))}
                    </div>
                </div>
                <div className="col">
                    <select className="custom-select" id="productSelect" value={selectedProduct} onChange={(e) => setSelectedProduct(e.target.value)}>
                        <option value="all">Все продукты</option>
                        <option value="course-html">Курс по верстке</option>
                        <option value="course-js">Курс по JavaScript</option>
                        <option value="course-vue">Курс по VUE JS</option>
                        <option value="course-php">Курс по PHP</option>
                        <option value="course-wordpress">Курс по WordPress</option>
                    </select>
                </div>
            </div>
        </form>
     );
}
 
export default TableControls;